import { A2AProviderName, CardPaymentProviderName } from '@nemuru-eng/js-api-client';

export const SinglePaymentProviderLogo = ({
  providers,
  size = 26,
  isActive = true,
  altColor = false,
}: {
  providers: (CardPaymentProviderName | A2AProviderName)[];
  size?: number;
  isActive?: boolean;
  altColor?: boolean;
}) => {
  const isIdleStyles = {
    filter: altColor ? 'brightness(0) invert(1)' : 'grayscale(1) contrast(0)',
    opacity: altColor ? 0.3 : 0.2,
  };

  if (!providers) return null;

  return (
    <>
      {providers.map((provider) => (
        <img
          key={provider}
          src={`/assets/providers_logo/logo-${provider}.png`}
          style={{ width: `${size}px`, height: 'auto', ...(isActive ? {} : isIdleStyles) }}
        />
      ))}
    </>
  );
};
